import {queryOptions, infiniteQueryOptions} from '@tanstack/react-query';
import {accountsRecoveryDatesList} from 'api/v2';
import type {AccountsRecoveryDatesListParams} from 'api/v2';

export const recoveryDatesQueryKeys = {
  all: () => ['recoveryDates'],
  currentForUser: (userId: string) => [
    ...recoveryDatesQueryKeys.all(),
    'currentForUser',
    userId,
  ],
  infiniteList: (params: AccountsRecoveryDatesListParams) => [
    ...recoveryDatesQueryKeys.all(),
    'infiniteList',
    params,
  ],
};

// The current recovery date is the newest history row (the list is ordered
// newest-first); empty results means the member has never set one. The
// `current/` endpoint can't be used here — it returns the caller's own row.
const currentForUser = (userId: string) =>
  queryOptions({
    queryKey: recoveryDatesQueryKeys.currentForUser(userId),
    queryFn: () => accountsRecoveryDatesList({userId, pageSize: 1}),
    select: (data) => data.data.results[0] ?? null,
  });

const recoveryDatesInfiniteList = (params: AccountsRecoveryDatesListParams) =>
  infiniteQueryOptions({
    queryKey: recoveryDatesQueryKeys.infiniteList(params),
    queryFn: async ({pageParam = 1}) => {
      const response = await accountsRecoveryDatesList({
        ...params,
        page: pageParam,
      });
      return {
        data: response.data,
        nextPage: response.data.next ? pageParam + 1 : null,
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
  });

export const recoveryDatesQueryOptions = {
  currentForUser,
  infiniteList: recoveryDatesInfiniteList,
};
